import React, { useEffect } from 'react';

// assets

// services

// props

// components
import { ActionButton, Link, Stack, TagPicker } from '@fluentui/react';
import Label from '../../../typography/label';
import Text from '../../../typography/text';
import { IShipResourceShortProps } from '../../../../props/data/ships';
import { IVendorResourceShortProps } from '../../../../props/data/vendors';
import PermissionsService from '../../../../services/permissions';
import { useStore } from '../../../../stores/root';
import { ITruckResourceShort } from '../../../../props/data/trucks';
import TruckForm from '../../../operationals/trucks/general/form';
import TrucksService from '../../../../services/data/trucks';

type SelectTruckProps = {
    vendor?: IVendorResourceShortProps;
    selected?: ITruckResourceShort;
    options?: IShipResourceShortProps[];
    qs?: string[];
    label?: string;
    hideLabel?: boolean;
    required?: boolean;
    disabled?: boolean;
    allowCreate?: boolean;
    onChange(selected?: ITruckResourceShort): void;
}

const SelectTruck: React.FC<SelectTruckProps> = (props: SelectTruckProps) => {
    const { user } = useStore();
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<ITruckResourceShort | undefined>();

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    useEffect(() => {
    }, [props]);

    const _onSearchTruck = async (keyword: string) => {
        try {
            if (props.options) {
                return props.options.map((item) => ({
                    key: item.id,
                    name: item.name,
                    metadata: item
                }));
            } else {
                const qs: string[] = props.qs || [];
                if (props.vendor) { qs.push(`vendor_id=${props.vendor.id}`) }
                if (keyword && keyword.trim() !== '') { qs.push(`search=${keyword}`) }

                const options = (await TrucksService.retrieve(qs.join("&"))).map((item) => ({
                    key: item.id,
                    name: item.name,
                    metadata: item
                }));

                return options;
            }
        } catch (error) {
            return [];
        }
    }

    return <Stack>
        {props.hideLabel ? null : <Label style={{padding: '3px 0px'}} size={'xsmall'} required={props.required}>{props.label || "Truck"}</Label>}
        {!selected ? <>
            <TagPicker
                disabled={props.disabled}
                selectedItems={[]}
                removeButtonAriaLabel='Remove'
                itemLimit={1}
                onItemSelected={(item: any) => {
                    const selected = item ? item.metadata : undefined;
                    props.onChange(selected);

                    return null;
                }}
                onRenderSuggestionsItem={(props: any) => {
                    const md = props.metadata as ITruckResourceShort;

                    return <Stack styles={{ root: { padding: 5 }}} horizontalAlign='baseline'>
                        <Label size={'small'}>{md.registrationNumber}</Label>
                        <Text size={'small'}>{md.vendor.name}</Text>
                    </Stack>;
                }}
                onResolveSuggestions={_onSearchTruck}
                onEmptyResolveSuggestions={() => _onSearchTruck('')}
            />
            {props.allowCreate && PermissionsService.hasPermission(['ships.create'], user.permissions) ? <Text size={'small'}>Cannot find truck? <Link onClick={() => {setActiveSurface('create')}}>Click here</Link> to create truck</Text> : null}
        </> : null}
        {selected ? <Stack styles={{ root: { padding: 8 } }} className={'card'} horizontal tokens={{ childrenGap: 20 }} horizontalAlign={'space-between'} verticalAlign='center'>
            <Stack>
                <Label size={'small'}>{selected.registrationNumber}</Label>
                {!props.vendor ? <Text size={'small'}>{selected.vendor.name}</Text> : null}
            </Stack>
            {!props.disabled ? <ActionButton iconProps={{ iconName: "Delete" }} onClick={() => { props.onChange(); }} /> : null}
        </Stack> : null}
        {activeSurface === 'create' ? <TruckForm vendorId={props.vendor?.id} onDismissed={(refresh, truck) => {
            setActiveSurface(undefined);
            props.onChange(truck);
        }} /> : null}
    </Stack>;
};

export default SelectTruck;
